import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Contact from './components/Contact';
import Testimonials from './components/Testimonials';
import PrivacyPolicy from './components/PrivacyPolicy';

function App() {
  return (
    <Router>
      <div className="app">
        <Header />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </main>
        <footer className="footer">
          <div className="footer-content">
            <p>Public Insurance Adjuster | Cara M Lawler | TX License# 295678 | 6904 Tulane Dr. Austin TX 78723</p>
            <nav className="footer-nav">
              <a href="/">Home</a>
              <a href="/contact">Contact</a>
              <a href="/testimonials">Testimonials</a>
              <a href="/privacy-policy">Privacy Policy</a>
            </nav>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;
